import _ from 'lodash';
import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
const { getSectionForPageByIdAndType } = contentfulModels;
import { fetchNoGlowforgePage } from 'app/common/api/common-api';
import NoGlowforge from 'app/components/no-glowforge';

const mapStateToProps = (state) => {
  const page = _.get(state, 'common.noGlowforgePage');
  return ({
    arrivedSection: getSectionForPageByIdAndType(page, 'onboarding-no-gf-arrived', 'textSection'),
    notArrivedSection: getSectionForPageByIdAndType(page, 'onboarding-no-gf-not-arrived', 'textSection'),
    addSomeonesSection: getSectionForPageByIdAndType(page, 'onboarding-no-gf-add-someones', 'textSection'),
    haventPurchasedSection: getSectionForPageByIdAndType(page, 'onboarding-no-gf-havent-purchased', 'textSection'),
    title: getSectionForPageByIdAndType(page, 'onboarding-no-gf-title', 'textString'),
    beginSetupButton: getSectionForPageByIdAndType(page, 'onboarding-begin-setup', 'buttonLink'),
  });
};

const hasInvitePageContent = dispatch =>
  Promise.all([
    dispatch(fetchNoGlowforgePage()),
  ]);

const NoGlowforgeContainer = connect(mapStateToProps)(preload(
  ({ dispatch }) => hasInvitePageContent(dispatch))(NoGlowforge),
);

export default NoGlowforgeContainer;



// WEBPACK FOOTER //
// ./app/containers/no-glowforge.js